import PropTypes from "prop-types";
import { faReceipt, faClockRotateLeft, faCalendarClock, faCreditCard, faComments, faShieldCheck } from "@fortawesome/pro-regular-svg-icons";
import LandingCard from "./LandingCard";

const Landing6th = ({ locale }) => {
    // define data for the cards
    const cards = [
        { key: 'card1', title: locale.cardTitleOne, content: locale.cardContentOne },
        { key: 'card2', title: locale.cardTitleTwo, content: locale.cardContentTwo },
        { key: 'card3', title: locale.cardTitleThree, content: locale.cardContentThree },
        { key: 'card4', title: locale.cardTitleFour, content: locale.cardContentFour },
        { key: 'card5', title: locale.cardTitleFive, content: locale.cardContentFive }
    ];

    return (
        <div className='landing-element-container' id="landing-page-6th">
            <div className='landing-element-content'>
                <div className="row">
                    <div className='col-lg-6 col-md-8 col-xs-12'>
                        <h1>{locale.title}</h1>
                        <p>{locale.subtitle}</p>
                    </div>
                </div>
                <div className="row landing-element-card-row g-0">
                    {cards.map((card) => (
                        <LandingCard
                            key={card.key}
                            title={card.title}
                            content={card.content}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

Landing6th.propTypes = {
    locale: PropTypes.object.isRequired
}

export default Landing6th;
